module.exports = __webpack_public_path__ + "img/s00171.2ae78581.png";